import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';

export default function ConfirmDialog({
    open,
    title,
    description,
    confirmLabel = 'Confirmar',
    cancelLabel = 'Cancelar',
    confirmColor = 'secondary',
    loading = false,
    onCancel,
    onConfirm,
}) {
    return (
        <Dialog
            open={open}
            onClose={loading ? undefined : onCancel}
            aria-labelledby="confirm-dialog-title"
            slotProps={{
                paper: {
                    sx: {
                        bgcolor: 'background.paper',
                        border: '1px solid',
                        borderColor: 'divider',
                        backgroundImage: 'none',
                        maxWidth: 420,
                    },
                },
            }}
        >
            <DialogTitle id="confirm-dialog-title" sx={{ fontFamily: 'DM Serif Display', pr: 3 }}>
                {title}
            </DialogTitle>
            {description && (
                <DialogContent>
                    <Typography sx={{ color: 'text.secondary', textWrap: 'pretty' }}>
                        {description}
                    </Typography>
                </DialogContent>
            )}
            <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onCancel}
                    disabled={loading}
                >
                    {cancelLabel}
                </Button>
                <Button
                    variant="contained"
                    color={confirmColor}
                    onClick={onConfirm}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={16} /> : undefined}
                >
                    {loading ? 'Aguarde...' : confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
